import { createContext } from 'react';
export const cultureContext = /*#__PURE__*/createContext({
  culture: undefined,
  financialSet: undefined,
  language: undefined,
  timeZone: undefined
});

/**
 * Stored language, culture settings, financial settings and timezone identification selected from the tenant culture settings.
 * @see {@link CultureContext} for more information about stored value.
 */
export const CultureProvider = cultureContext.Provider;
//# sourceMappingURL=cultureContext.js.map